import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
// import WhyStudyAbroad from './WhyStudyAbroad'
// import Browse from './Browse'
// import Whatsnew2 from './whatsnew2'
// import StartTestimonials from './testimonials'
// import Aboutsection from './aboutsection'
// import IndividualUniversity from './IndividualUniversity'
import CountUp from 'react-countup'
// import Destination from './Destination'
import Pagination from '../../StudyDestination/Australia/Pagination';

import Whatsnew from './whatsnew'
import Aboutus from './about-us'
import SearchFilterSort from './SearchFilterSort'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetUniversitiesWithFiltersApiQuery } from '../../../core/Features/api/findACourse/university/university';
import { useSelector } from 'react-redux';
import Unlock from '../../HomePages/home-palani/section/Unlock';
import { useGetHomepageApiQuery } from '../../../core/Features/api/homepage/homePageApi';
// import Becomeinstructor from './Becomeinstructor';
import Becomeinstructor from '../../HomePages/home-palani/section/become-instructor';
// import Benefits from './Benefits'
// import About from './about-us'

const University = () => {

    // filterDestination
    const [searchakash, setSearchAkash] = useState<string>('');
    const [akash2, setAkash2] = useState<string>('');
    const [akash3, setAkash3] = useState()
    const reduxValue = useSelector((state: any) => state?.common?.commonData?.filterDestination)

    const [page, setPage] = useState(1);
    const limit = 9; // item per page

    const queryParams = [
        `sortBy=${akash2 == "rankingNumber" ? "rankingNumber" : "title"}`,
        `order=${akash2 == "asc" || akash2 == "desc" ? akash2 : "asc"}`,
        `parentIds=${reduxValue?.countries?.join(",")}`,
        `search=${encodeURIComponent(searchakash)}`, // <-- comma added here
        `page=${page}`,
        `limit=${limit}`
    ].join("&");

    const { data, isLoading, isError } = useGetUniversitiesWithFiltersApiQuery(queryParams);
    const { data: dataCard } = useGetHomepageApiQuery({});

    const apiValues = data?.data || {};
    const apiValues2 = data?.pageDetails || {};
    const apiValues3 = data?.destinations || {};
    const totalPages = data?.totalPages
    // const totalPages = Math.ceil(apiValues?.totalPages)

    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);

    return (
        <>
            <>

                {/* banner */}

                <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0 bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues2?.bannerImageUrl})`,
                                                        backgroundSize:"100% 100%",

                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues2?.bannerTitle}
                                            </h6>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <div className='p-3'>

                    <SearchFilterSort setSearchAkash={setSearchAkash} setAkash2={setAkash2} setAkash3={setAkash3} apiValues={apiValues3} />
                    <Whatsnew apiValues={apiValues} />
                    <div className="flex flex-col justify-end items-end p-1">
                        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
                    </div>
                    {/* <div className='mt-4'> */}
                        {/* <Becomeinstructor apiValues5={dataCard?.data?.bottomTwoCard || {}} /> */}
                        <Becomeinstructor apiValues={dataCard?.data?.bottomTwoCard || {}}/>
                    {/* </div> */}
                    {/* <Aboutus /> */}

                    <Unlock />

                </div>




            </>

        </>
    )
}

export default University





